var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Button-group u-flex u-flex-spaceBetween"},[_c('div',{staticClass:"left-container"},[_vm._t("left-aligned-buttons")],2),_vm._v(" "),_c('div',{staticClass:"right-container"},[_vm._t("right-aligned-buttons")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }